import { BaseRequestQueryParam, FutureResponseModel, HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { CancelToken } from 'axios';
import { getLocalStorage } from 'utils/sessionStorage';

const futureApi = {
  getFutures: (
    params: BaseRequestQueryParam,
    cancelToken: CancelToken,
  ): Promise<HttpResponse<FutureResponseModel[]>> => {
    const url = `/terabet/api/futures`;
    const token = getLocalStorage('access_token_terabet');

    const config = {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      params,
      cancelToken,
    };
    return handleRequest(axiosClient.get(url, config));
  },
};

export default futureApi;
